import { OsAttendanceModel } from '@/domain/models'
import { GetOsAttendance, GetOsAttendanceParams } from '@/domain/usecases'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols'
import { AccessDeniedError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'

export class RemoteGetOsAttendance implements GetOsAttendance {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<OsAttendanceModel[]>
  ) {}

  async getAttendences (params: GetOsAttendanceParams): Promise<OsAttendanceModel[]> {
    const request: HttpRequest = {
      url: `${this.url}/api/osatendimentos`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(request)

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (!body) {
          throw new UnexpectedResultFormatError()
        }

        return body
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
